import { Awsdk } from 'lib/amwell/sdk/types';
import { AmwellClient } from '../index';

export default class BaseService {
  sdk!: Awsdk;

  constructor(amwellClient: AmwellClient) {
    this.sdk = amwellClient.sdk;
  }
}
